module.exports = __webpack_public_path__ + "img/ko.c7a18eae.png";